import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import featureImg from './img/feature-img.avif';
import css from './AboutPage.module.css';

const SectionFeature = () => {
  return (
    <div className={css.sectionFeature}>
      <img className={css.featureImg} alt="Performing" src={featureImg} />
      <div className={css.featureContent}>
        <h2 className={css.featureTitle}>
          <FormattedMessage id="AboutPage.featureTitle" />
        </h2>
        <p className={css.featureText}>
          <FormattedMessage id="AboutPage.featureText" />
        </p>
      </div>
    </div>
  );
};

export default SectionFeature;
